// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"auth-layout_contentWrapper__A_Hfo"};